import { useMatchMedia } from '#app/hooks/useMatchMedia.js';
import { parseMediaQueryForMatchMedia } from '#app/utilities/parseMediaQueryForMatchMedia.js';
import { TRANSACTION_LOG_DESKTOP_BP } from '../constants.js';
import { useTheme } from 'styled-components';

export const useIsDesktop = () => {
  const theme = useTheme();
  const isDesktop = useMatchMedia(
    parseMediaQueryForMatchMedia(
      theme.mediaQueries[TRANSACTION_LOG_DESKTOP_BP],
    ),
  );
  return isDesktop;
};
